// import { postMmkAnalytics } from "../axios/mmk";

type AnalyticsPayload = Record<string, unknown>;

declare global {
  interface Window {
    analytics?: { track?: (event: string, payload?: AnalyticsPayload) => void };
    posthog?: { capture?: (event: string, payload?: AnalyticsPayload) => void };
  }
}

export const trackMmkEvent = (event: string, payload: AnalyticsPayload = {}): void => {
  if (typeof window === "undefined") return;

  // Send to backend for tracking user actions
  // postMmkAnalytics(event, payload);

  window.analytics?.track?.(event, payload);
  window.posthog?.capture?.(event, payload);
};
